<!-- Begin page content -->
<main class="flex-shrink-0">
  <div class="container">

    <!-- Champions section -->
    <section id="champions">
      <div *ngIf="winnersList" class="champions-content">
        <div class="container">
          <div class="row mt-3">
            <div class="col-lg-6">
              <span class="title">Чемпионы и призеры</span>
            </div>
            <div class="col">
              <div class="line"></div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-xl-3 col-lg-6 col-md-6" *ngFor="let item of winnersList">
              <div class="card champs" (click)="redirectToWinnersPage(item)">
                <!-- <img src="../../assets/img/kozha.png" class="card-img-top" alt="..."> -->
                <img src="{{item.image}}" alt="">
                <div class="card-body">
                  <h5 class="card-title">{{item.name}}</h5>
                  <p class="card-text">{{item.degree}}</p>
                  <!-- <a href="#" class="btn btn-primary">Go somewhere</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="no-results" [ngClass]="{block: noWinnersList, none: winnersList}">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="no-results-found-block text-center">
              <img src="../../assets/img/main/error.png" alt="" width="200">
              <div class="mt-2">
                <h2 style="font-weight: 600;">Результатов не найдено</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
